<template>
    <div class="container overflow-hidden search-layout">
        <search-plans-category-modal
            ref="planCategoryModal"
            :company-id="companyId"
            :token="token"
            :use-route-query="true"
        />
        <div class="row g-0">
            <div class="col-12">
                <search-box :company-id="companyId" :token="token" :radius-id="radiusId"></search-box>
            </div>
        </div>
        <div class="row ac-panel-content">
            <div class="order-sm-2 order-md-2 order-lg-1 order-xl-1 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <provider-profile-layout
                    v-if="showInlineProfile"
                    :company-id="companyId"
                    :token="token"
                    :provider-entity-id="singleResultProviderEntityId"
                    :plan-category-id="selectedPlanCategoryId"
                    @back-to-search="onBackToSearchFromProfile"
                ></provider-profile-layout>
                <search-results-presenter v-else :company-id="companyId" :token="token"></search-results-presenter>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import SearchBox from "./SearchBox.vue";
    import SearchResultsPresenter from "./SearchResultsPresenter.vue";
    import ProviderProfileLayout from "../providerProfile/ProviderProfileLayout.vue";
    import SearchPlansCategoryModal from "@/pages/member/components/SearchPlansCategoryModal.vue";

    export default {
        name: "SearchLayout",
        components: {SearchPlansCategoryModal, ProviderProfileLayout, SearchResultsPresenter, SearchBox},
        props: {
            companyId: {type: [Number], required: true},
            token: {type: [String], required: true},
            radiusId: {type: [Number], required: true}
        },
        data() {
            return {
                /** When search returns one provider, show list instead of auto-inline profile after back */
                forceListView: false,
            };
        },
        computed: {
            ...mapGetters(['searchResults']),
            singleResultProviderEntityId() {
                if (!Array.isArray(this.searchResults) || this.searchResults.length !== 1) {
                    return null;
                }
                const providerEntityId = this.searchResults[0].providerEntityId;
                return typeof providerEntityId === 'undefined' || providerEntityId === null
                    ? null
                    : Number(providerEntityId);
            },
            selectedPlanCategoryId() {
                const rawPlanCategoryId = this.$route && this.$route.query
                    ? this.$route.query.planCategoryId
                    : null;
                if (rawPlanCategoryId === null || rawPlanCategoryId === '' || typeof rawPlanCategoryId === 'undefined') {
                    return null;
                }
                const value = Number(rawPlanCategoryId);
                return Number.isNaN(value) ? null : value;
            },
            showInlineProfile() {
                return this.singleResultProviderEntityId !== null && !this.forceListView;
            },
        },
        watch: {
            $route: {
                immediate: true,
                handler(to) {
                    this.forceListView = false;
                    if (to.name === 'search' && !this.hasPlanCategoryInRoute(to)) {
                        this.promptPlanCategoryIfNeeded();
                    }
                },
            },
        },
        methods: {
            onBackToSearchFromProfile() {
                this.forceListView = true;
            },
            hasPlanCategoryInRoute(route = this.$route) {
                const raw = route.query.planCategoryId;
                return raw !== undefined && raw !== null && raw !== '';
            },
            promptPlanCategoryIfNeeded() {
                this.$nextTick(() => {
                    if (this.$refs.planCategoryModal && !this.hasPlanCategoryInRoute()) {
                        this.$refs.planCategoryModal.openOnLandingIfNeeded();
                    }
                });
            },
        },
    }
</script>

<style scoped>
    .search-layout {
        background-color: rgb(240, 239, 239);
    }
</style>